(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    	.controller('LogoutController', logout)
    	;

  logout.$inject = ['$scope', '$location', 'AuthenticationService', '$http', 'LoginService', '$rootScope', 'LocalStorageService'];

  function logout ($scope, $location, AuthenticationService, $http, LoginService, $rootScope, LocalStorageService) {
    	var vm = this;
    	$scope.vm = vm;

    vm.doLogout = doLogout;
    doLogout();

    function doLogout () {
      LoginService
        .logLogout({ user: $rootScope.user_data.id })
        .$promise
        .then(function (data) {
          if (data.success) {
            AuthenticationService.ClearCredentials();
            LocalStorageService.clearUserPauseState();
            window.location.href = loginUrl;
          }
        }).catch(function (error) {
          AuthenticationService.ClearCredentials();
          LocalStorageService.clearUserPauseState();
        });
    }
  }
})();
